import type { DeviceTrackPoints } from './types';

/** Sorted unique timestamps from all device tracks (event timeline). */
export function buildEventTimeline(
  tracks: readonly DeviceTrackPoints[],
): number[] {
  const set = new Set<number>();
  for (const track of tracks) {
    for (const p of track.points) {
      if (Number.isFinite(p.timestampSec)) set.add(p.timestampSec);
    }
  }
  return [...set].sort((a, b) => a - b);
}
